import { t, useLocale } from '../lib/i18n.js';
import { useStore } from '../lib/store.js';

export function ConnStatus() {
  useLocale();
  const status = useStore((s) => s.status);
  const rtt = useStore((s) => s.rttMs);
  const label =
    status === 'open'
      ? t(
          `Connected${rtt !== null ? ` · ${rtt}ms` : ''}`,
          `接続中${rtt !== null ? ` · ${rtt}ms` : ''}`,
        )
      : status === 'reconnecting'
        ? t('Reconnecting…', '再接続中…')
        : status === 'connecting'
          ? t('Connecting…', '接続しています…')
          : t('Offline', '切断');
  return <span className={`conn${status === 'open' ? '' : ' conn--bad'}`}>{label}</span>;
}
